var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var InfoIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C21.9940293,6.47962754 17.5203725,2.00597071 12,2 Z M12.2083333,6.16666667 C12.8986893,6.16666667 13.4583333,6.72631073 13.4583333,7.41666667 C13.4583333,8.1070226 12.8986893,8.66666667 12.2083333,8.66666667 C11.5179774,8.66666667 10.9583333,8.1070226 10.9583333,7.41666667 C10.9583333,6.72631073 11.5179774,6.16666667 12.2083333,6.16666667 Z M14.0833333,17.4166667 L10.75,17.4166667 C10.2897627,17.4166667 9.91666667,17.0435706 9.91666667,16.5833333 C9.91666667,16.123096 10.2897627,15.75 10.75,15.75 L11.375,15.75 C11.4900593,15.75 11.5833333,15.656726 11.5833333,15.5416667 L11.5833333,11.7916667 C11.5833333,11.6766073 11.4900593,11.5833333 11.375,11.5833333 L10.75,11.5833333 C10.2897627,11.5833333 9.91666667,11.2102373 9.91666667,10.75 C9.91666667,10.2897627 10.2897627,9.91666667 10.75,9.91666667 L11.5833333,9.91666667 C12.5038079,9.91666667 13.25,10.6628588 13.25,11.5833333 L13.25,15.5416667 C13.25,15.656726 13.343274,15.75 13.4583333,15.75 L14.0833333,15.75 C14.5435706,15.75 14.9166667,16.123096 14.9166667,16.5833333 C14.9166667,17.0435706 14.5435706,17.4166667 14.0833333,17.4166667 Z"
}));
export var InfoIcon = function InfoIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "InfoIcon ".concat(className || '')
  }), InfoIconShape);
};